import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BackdropLoader, SimpleModal } from '@livable/saas-react-components';
import { Button, Alert, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RECCURING_TRANSACTION_STATUS } from 'src/constants/payments';
export default function CancelModal(_ref) {
  var _activeTransaction$po;
  let modalState = _ref.modalState,
    handleOpenExternal = _ref.handleOpenExternal,
    handleCloseExternal = _ref.handleCloseExternal,
    activeTransaction = _ref.activeTransaction,
    onSaveHandler = _ref.onSaveHandler;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const GetContent = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Alert, {
      severity: "info",
      icon: false,
      size: "small"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, t('resident_account.cancel_charge_desc'))), /*#__PURE__*/React.createElement(BackdropLoader, {
      isOpen: isLoading
    }));
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: handleCloseExternal,
    handleOpen: handleOpenExternal,
    isOpen: modalState,
    title: t('resident_account.cancel_recurring_charge', {
      transactionType: activeTransaction === null || activeTransaction === void 0 || (_activeTransaction$po = activeTransaction.postType) === null || _activeTransaction$po === void 0 ? void 0 : _activeTransaction$po.toLowerCase()
    }),
    noPadding: true,
    rightButton: /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      disabled: isLoading,
      onClick: async () => {
        onSaveHandler(activeTransaction);
        setIsLoading(true);
        await onSaveHandler(_objectSpread(_objectSpread({}, activeTransaction), {}, {
          status: RECCURING_TRANSACTION_STATUS.Inactive
        }));
        setIsLoading(false);
        handleCloseExternal();
      },
      'custom-attribute': '48-reccuring-charges-table-delete-modal'
    }, t('resident_account.yes_i_do'))
  }, /*#__PURE__*/React.createElement(GetContent, null));
}